export default __webpack_public_path__ + "static/media/celular-ferramentas.9ec03c1f.png";